import React from 'react'

import { Grid } from '@material-ui/core/'

import InviteSent from './InviteSent'
import LoadingIcon from './LoadingIcon'

const FriendInvites = ({ aid, results }) => {
  let resultsList = []

  let unfilteredInvites = results

  if (unfilteredInvites !== undefined) {
    if (unfilteredInvites.length > 0) {
      let filteredInvites = []

      // Make sure we don't pass along accepted invites or duplicates
      for (let i = 0; i < unfilteredInvites.length; i++) {
        let passDown = true

        // First check to make sure we don't have this invite in the array already
        // We need to do this first to make sure that invites that are duplicates of accepted invites aren't inserted
        for (let j = 0; j < unfilteredInvites.length; j++) {
          if (i !== j) {
            if (
              unfilteredInvites[i].inviteeEmailAddress !== undefined &&
              unfilteredInvites[j].inviteeEmailAddress !== undefined
            ) {
              if (
                unfilteredInvites[i].inviteeEmailAddress ===
                unfilteredInvites[j].inviteeEmailAddress
              ) {
                passDown = false
              }
            }
            if (
              unfilteredInvites[i].inviteePhoneNumber !== undefined &&
              unfilteredInvites[j].inviteePhoneNumber !== undefined
            ) {
              if (
                unfilteredInvites[i].inviteePhoneNumber ===
                unfilteredInvites[j].inviteePhoneNumber
              ) {
                passDown = false
              }
            }
          }

          // Removing the entries from the unfiltered array is unnecessary, we just have to make sure we don't copy them to the filtered array
          // if (passDown === false) {
          //   let splicedInvites = unfilteredInvites.splice(i, 1)
          //   let splicedTwiceInvites = splicedInvites.splice(j-1, 1)
          //   i = i - 2
          // }
        }

        // Then check to see that the results are appropriate
        if (passDown === true && unfilteredInvites[i].acceptDate === -1) {
          filteredInvites.push(unfilteredInvites[i])
        }
      }

      filteredInvites = filteredInvites.map(item => {
        if (item.acceptDate === -1) {
          return <InviteSent key={item.inviteDate} aid={aid} invite={item} />
        }
      })
      resultsList = (
        <div>
          <h3 className="large text-center">Invites Sent</h3>
          <ul className="contacts-list">{filteredInvites}</ul>
        </div>
      )
    } else {
      resultsList = (
        <div>
          <h3 className="large text-center">Invites Sent</h3>
          <p className="text-center">
            <strong>You don't have any pending invites</strong>
          </p>
        </div>
      )
    }
  } else {
    resultsList = (
      <Grid container spacing={24}>
        <Grid item xs />
        <Grid item xs={10} sm={6} md={4}>
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <LoadingIcon />
          </div>
        </Grid>
        <Grid item xs />
      </Grid>
    )
  }

  return <div>{resultsList}</div>
}

export default FriendInvites



// WEBPACK FOOTER //
// ./src/Components/FriendInvites.js